import React, { useEffect, useState } from 'react';
import './Toggle.scss';

export default function Toggle({ onChange, value }) {
	const [toggleValue, setToggleValue] = useState(!!value);

	// Sempre que o prop `value` mudar, reflita no estado interno
	useEffect(() => {
		setToggleValue(!!value);
	}, [value]);

	const handleChange = (ev) => {
		const checked = ev.target.checked;
		setToggleValue(checked); // atualiza o estado interno
		if (onChange) onChange(checked); // avisa o pai
	};

	return (
		<label className="switch">
			<input
				type="checkbox"
				checked={toggleValue} // <-- aqui
				onChange={handleChange}
			/>
			<span className="slider round"></span>
		</label>
	);
}
